export default "__VITE_ASSET__gsf4FzHD__"